import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChartLine, FaMapMarkerAlt, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { getTerminalName } from '../utils/terminalNames';

const TerminalCard = ({ terminal }) => {
  const navigate = useNavigate();
  const displayName = getTerminalName(terminal);

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-lg hover:border-emerald-200 transition-all duration-200 cursor-pointer group"
         onClick={() => navigate(`/graficos/${terminal.guid}`)}>
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="font-bold text-gray-900 group-hover:text-emerald-600 transition-colors">{displayName}</h3>
          <p className="text-xs text-gray-500 font-mono mt-1">GUID: {terminal.guid}</p>
          {terminal.ubicacion && (
            <p className="text-xs text-gray-500 flex items-center gap-1 mt-1">
              <FaMapMarkerAlt className="w-3 h-3" /> {terminal.ubicacion}
            </p>
          )}
        </div>
        {terminal.estado ? (
          <span className="flex items-center gap-1 text-xs text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full font-medium">
            <FaCheckCircle className="w-3 h-3" /> Activo
          </span>
        ) : (
          <span className="flex items-center gap-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded-full font-medium">
            <FaTimesCircle className="w-3 h-3" /> Inactivo
          </span>
        )}
      </div>

      <p className="text-sm text-gray-600 mb-4 line-clamp-2">{terminal.descripcion || 'Sin descripción'}</p>

      <button className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-gray-50 hover:bg-emerald-50 text-gray-600 hover:text-emerald-600 border border-gray-200 hover:border-emerald-200 rounded-lg text-sm font-medium transition-all">
        <FaChartLine className="w-4 h-4" />
        Ver Gráficos
      </button>
    </div>
  );
};

export default TerminalCard;
